import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { Color } from "../../../Domain/Model/Color";
import CategoryDataSource from "../ColorDataSource";
import { ColorAPIEntity } from "./Entity/ColorAPIEntity";

const routeName = `/v1/color`;

 
export default class ColorAPIDataSourceImpl implements CategoryDataSource {

     async createColor(data: Color): Promise<ColorAPIEntity[]> {
      try {
        // Define los datos que deseas enviar en la petición POST
        const postData = {
          name: data.name,
        };
    
        // Realiza la petición POST utilizando api
        const response = await api.post<ApiResponse<any>>(routeName, postData);
    
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Mapea los datos de la respuesta al formato de CategoryAPIEntity que esperas
          const colors = response.data.data;
    
          return colors;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al agregar el color:", error);
        throw new Error("Error al agregar el color");
      }
    }


    async getColors(): Promise<ColorAPIEntity[]> {
      try {
        const response = await api.get<ApiResponse<any>>(routeName, {
          headers: {
            'Content-Type': 'application/json',
            'accept': '*/*'
          }
        });
        // console.log(response.data.data);
        const listColors = response.data.data;
        // Verifica si la respuesta contiene datos
        if (listColors && Array.isArray(listColors)) {
          // Mapea los datos de la respuesta al formato de Category que esperas
          const colors: Color[] = listColors.map((item: any) => ({
            id: item.id,  
            name: item.name, 
          }));
  
          return colors;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al obtener los colores:", error);
        throw new Error("Error al obtener los colores");
      }
    }

    async updateColor(data: Color): Promise<boolean> {
      try {
        // Realiza la petición PUT utilizando api
        const response = await api.put<ApiResponse<any>>(`${routeName}`, data);
  
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Devuelve true si la actualización fue exitosa
          return true;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al actualizar el color:", error);
        throw new Error("Error al actualizar el color");
      }
    }

    async removeColor(id: string): Promise<boolean> {
      try {
        // Realiza la petición DELETE utilizando api
        const response = await api.delete<ApiResponse<any>>(`${routeName}/${id}`);
  
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Devuelve true si la eliminación fue exitosa
          return true;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al eliminar el color:", error);
        throw new Error("Error al eliminar el color");
      }
    }
  }